import React, { useEffect } from 'react'
import styles from "./Login.module.css"
import axios from 'axios'
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {getLogin} from "../../Redux/auth/action"

export const Login = () => {
  const navigate=useNavigate()
const [login,setlogin]=React.useState({})
const[log,setlog]=React.useState([])
  const[otp,setotp]=React.useState(false);
    const[pswd,setpswd]=React.useState(false)

  const [logedin, setlogedin] = React.useState(0);
  const { isLoading, isAuth } = useSelector((state) => {
    return {
      isLoading: state.authReducer.isLoading,
      isAuth: state.authReducer.isAuth
    }
  })
  const dispatch = useDispatch();

  const handlesignup=(e)=>{
    setlogedin(logedin+1)
    setlogin({...login,
        [e.target.value]:e.target.value,
    })
        
  }
  
  const handleclick=()=>{
    dispatch(getLogin());
setotp(true)
setlog([...log,login])
    console.log(log)
    const payload={
      email:log,
    }
    axios.post("https://learn-heroku-api.herokuapp.com/users", payload)
      .then((r) => console.log(r.data))
  }
  const handleclick2=()=>{
    dispatch(getLogin());
setpswd(true)
setlog([...log,login])
    console.log(log)
    const payload={
      email:log,
    }
    axios.post("https://learn-heroku-api.herokuapp.com/users", payload)
      .then((r) => console.log(r.data))
  }


// localStorage.setItem("data",JSON.stringify(log))
// const data1 = JSON.parse(localStorage.getItem("data"));
// setlogedin(data1)
//   for(var i=0;i<logedin.length;i++){
//     if(login.email==logedin[i].email){
// alert("You have already loged in")
//     }else{
//     alert('enter otp')}
//   }
  // const handleHome = () => {
  //   navigate("/",{replace:true})
  // }
  const handleFundraiser = () => {
    navigate("/medical",{replace:true})
  }
  const handleHome = () => {
    navigate("/",{replace:true})
  }
  return (
    <div className={styles.a}>
<div className={styles.b}>
  <h2>Login</h2><br/><br/><br/>
</div>

<div className={styles.c}>
<div style={{borderRight:'1px solid lightgray' , padding:'2%'}}>
  {/* <h5 className={styles.d}>Email/Mobile Number</h5> */}
  <input name='email' maxLength={30} onChange={handlesignup} placeholder='Email/Mobile Number' className={styles.text} type='search'></input>
          <br />
  <div>{(otp==true? <Otp/>:null)}</div><br/>

  {/* <div>{(otp=='1234'&&(otp==true)?alert('you have successfully loged in')}</div> */}
          <button disabled={logedin <= 0} onClick={!isAuth ? handleclick : handleHome} className={styles.f}>{!isAuth ? "Get OTP" : "Login"}</button>
          <br />
          <div>{(pswd==true? <Password/>:null)}</div><br/>
  <h5 style={{color:'rgb(1,191,189)'}} disabled={logedin <= 0} onClick={!isAuth ? handleclick2 : handleHome}>Login via Password</h5>
  <h6 className={styles.e}>By continuing you are agree to our <span style={{color:'rgb(1,191,189)'}}>  <a style={{color:'rgb(1,191,189)'}} href='https://www.ketto.org/terms-of-use.php' target='blank'>Terms of Service</a> </span> and <span style={{color:'rgb(1,191,189)'}}> <a style={{color:'rgb(1,191,189)'}}  href='https://www.ketto.org/privacy-policy.php' target='blank'>Privacy Policy</a> </span></h6>
  <h3 >Want to start a fundraiser? <span style={{color:'rgb(1,191,189)'}} onClick={handleFundraiser}>Click here</span></h3>
</div>
<div className={styles.h}>OR</div>

{/* <div className={styles.g} > */}
 <button className={styles.i}><img style={{height:'30px',borderRadius:'20px'}} src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7Le_mJ0fXYn2TP9qDaYb5-mDZ0HYb8rZdzQ&usqp=CAU'/>
 <h5>Sign with Google</h5>
 {/* <h4> */}
 {/* </h4> */}
 </button>
 {/* <button style={{color:'red' ,height:'3rem' , background: 'rgb(66,133,244)', borderColor: 'rgb(66,133,244)' }}>Sign in with Google</button> */}

{/* </div> */}



</div>



    </div>
  )
}
export function Otp(){
  return (<>
    <input maxLength={8}  placeholder='Enter OTP' className={styles.text} type='search'></input>

  
  </>)
}

export function Password(){
  return (<>
    <input maxLength={8}  placeholder='Enter Password' className={styles.text} type='search'></input>

  
  </>)
}





